import src from "IMAGE";
export default { src, width: 243, height: 243, blurWidth: 0, blurHeight: 0};
